export default "__VITE_ASSET__oNzq3K5Q__"